import React from "react";
import { Title, ReviewsList, ReviewsModal, Seo } from "../components";
import { PAGE_SEO } from "../common";
import "./style.css";

export const ReviewsPage = () => {
  return (
    <>
      <Seo {...PAGE_SEO.reviews} />
      <div className="container container-margin">
        <Title as="h1" title="Reviews" />
        <ReviewsList />
        <ReviewsModal />
      </div>
    </>
  );
};
